export const SEARCH_ARTICLES = 'SEARCH_ARTICLES';
export const GET_SEARCH_TERMS = 'GET_SEARCH_TERMS';
export const ARTICLES_RETURNED = 'ARTICLES_RETURNED';
export const ARTICLES_ERROR = 'ARTICLES_ERROR';